export function routerPushWithFilters(router, location) {
  try {
    localStorage.setItem('lastFilterListUrl', router.currentRoute.fullPath)
  } catch (e) {}

  return router.push(location)
}

export function returnToLastList(router, fallbackPath) {
  const prev = localStorage.getItem('lastFilterListUrl')
  try {
    localStorage.removeItem('lastFilterListUrl')
  } catch (e) {}

  if (prev?.startsWith(fallbackPath)) {
    router.push(prev)
  } else {
    router.push(fallbackPath)
  }
}
